import { memo, useMemo, type ReactNode } from 'react';
import { parseInlineTerms } from '../utils/inline-terms';
import { TermHighlight } from './term-highlight';

interface FormattedInlineTextProps {
  text: string;
  className?: string;
}

export const FormattedInlineText = memo(({ text, className }: FormattedInlineTextProps) => {
  const segments = useMemo(() => parseInlineTerms(text), [text]);
  const nodes = useMemo(() => {
    const rendered: ReactNode[] = [];
    let termIndex = 0;

    for (const segment of segments) {
      if (segment.type === 'plain') {
        if (segment.text) rendered.push(segment.text);
        continue;
      }

      const index = termIndex++;
      rendered.push(
        <TermHighlight
          key={`term-${index}`}
          term={segment.term}
          definition={segment.definition}
        />
      );
    }

    return rendered;
  }, [segments]);

  if (className) {
    return <span className={className}>{nodes}</span>;
  }

  return <>{nodes}</>;
});

FormattedInlineText.displayName = 'FormattedInlineText';
